import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import {
    ApplicationConfig,
    ErrorHandler,
    inject,
    provideAppInitializer,
    provideZonelessChangeDetection
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, Router } from '@angular/router'
import * as Sentry from '@sentry/angular'
import { InitService } from '@ui-core/services/init.service'
import {
    AutoRefreshTokenService,
    CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    customBearerTokenInterceptor,
    provideKeycloak,
    UserActivityService,
    withAutoRefreshToken
} from 'keycloak-angular'
import Keycloak from 'keycloak-js'
import { providePrimeNG } from 'primeng/config'
import { DialogService } from 'primeng/dynamicdialog'
import { routes } from './app.routes'
import CustomPreset from './customPreset'
import { environment } from './load.env'

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: CustomPreset,
                options: {
                    darkModeSelector: '.dark'
                }
            }
        }),
        provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([customBearerTokenInterceptor])),
        {
            provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [
                {
                    shouldAddToken: async (_: Request, __: Response, keycloak: Keycloak) => {
                        return keycloak.authenticated
                    }
                }
            ]
        },
        provideKeycloak({
            config: {
                realm: environment.KEYCLOAK_REALM,
                url: environment.KEYCLOAK_ENDPOINT,
                clientId: environment.KEYCLOAK_CLIENT_ID
            },
            initOptions: {
                onLoad: environment.KEYCLOAK_OPTIONS.ON_LOAD,
                checkLoginIframe: environment.KEYCLOAK_OPTIONS.CHECK_LOGIN_IFRAME,
                scope: environment.KEYCLOAK_OPTIONS.SCOPE
            },
            features: [
                withAutoRefreshToken({
                    onInactivityTimeout: environment.KEYCLOAK_OPTIONS.ON_INACTIVITY_TIMEOUT,
                    sessionTimeout: environment.KEYCLOAK_OPTIONS.SESSION_TIMEOUT
                })
            ],
            providers: [AutoRefreshTokenService, UserActivityService]
        }),
        provideAppInitializer(() => {
            const initService = inject(InitService)
            initService.initApiUrl()
        }),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
                logErrors: true
            })
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        },
        Sentry.TraceService,
        DialogService
    ]
}
